module.exports = __webpack_public_path__ + "style/img/DI_icon_Dev.783a363c.png";